import { DropdownMenu } from '@octopus-do/octopus-storybook'
import type React from 'react'

interface Props {
  active: string
}

export const SortOptions: React.FC<Props> = ({ active }) => (
  <>
    <DropdownMenu.Button
      title="Hierarchy"
      id="hierarchy"
      active={active === 'hierarchy'}
    />
    <DropdownMenu.Button
      title="Changes first"
      id="changes"
      active={active === 'changes'}
    />
    <DropdownMenu.Button
      title="Problems first"
      id="problems"
      active={active === 'problems'}
    />
  </>
)
